import React, { memo, useCallback } from 'react'
import { connect } from 'react-redux'

import { openDialog, closeDialog } from '../../../../../Forms/SharedComponents/containers/Dialog/actions/dialogActions'
import { OperacionesEnSiloView } from '../components/OperacionesEnSiloView'
import { OperacionesCubicaje } from '../operacionesCubicaje/containers/OperacionesCubicaje'
import { OperacionesFumigado } from '../operacionesFumigado/containers/OperacionesFumigado'
import { OperacionesMovimientos } from '../operacionesMovimientos/containers/OperacionesMovimientos'
import { OperacionesTransile } from '../operacionesTransile/containers/OperacionesTransile'

export const OperacionesEnSilo = connect(null, { openDialog, closeDialog })(
  memo(({ silo, openDialog, closeDialog }) => (
    <OperacionesEnSiloView
      silo={silo}
      openDialogOperacionesMovimientosSilo={() => openDialog(<OperacionesMovimientos silo={silo} />, 'OPERACIONES_MOVIMIENTO_DE_SILO')}
      openDialogOperacionesCubicajeSilo={() => openDialog(<OperacionesCubicaje silo={silo} />, 'OPERACIONES_DE_CUBICAJE_DE_SILO')}
      openDialogOperacionesFumigadoSilo={() => openDialog(<OperacionesFumigado silo={silo} />, 'OPERACIONES_DE_FUMIGADO_DE_SILO')}
      openDialogOperacionesTransileSilo={() => openDialog(<OperacionesTransile silo={silo} />, 'OPERACIONES_DE_TRANSILE_DE_SILO')}
      cancelar={useCallback(() => {
        closeDialog('OPERACIONES_EN_SILO')
      }, [closeDialog])}
    />
  ))
)
